import { render, staticRenderFns } from "./ProductCode.vue?vue&type=template&id=3c1ef23c&scoped=true"
import script from "./ProductCode.vue?vue&type=script&lang=js"
export * from "./ProductCode.vue?vue&type=script&lang=js"
import style0 from "./ProductCode.vue?vue&type=style&index=0&id=3c1ef23c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1ef23c",
  null
  
)

export default component.exports